module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_3_2-3bc497e01a32f98480cc40474ee7d6ce.png";